var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { DomOpsService } from '../dom/dom-ops.service';
import { HelperServiceService } from '../helpers/helper-service.service';
import { Card } from 'src/app/components/l2/content/primary-container/cards/card/card.model';
import * as $ from 'node_modules/jquery/dist/jquery';
var CardService = /** @class */ (function () {
    function CardService(domOpsService, helperService) {
        this.domOpsService = domOpsService;
        this.helperService = helperService;
        this.cards = [];
    }
    CardService.prototype.renderCards = function () {
        var localHistory = JSON.parse('{"createrepo":[],"createissue":[],"closeissue":[],"addissuecomment":[],"displaylastcomment":[],"addcollab":[],"viewrepos":[],"queries":[{"command":"create repo","type":"command","insertionCounter":1},{"command":"create repo","type":"command","insertionCounter":2}],"messages":[],"insertionCounter":2}');
        $("#conversations").empty();
        // const historyAll = this.helper.concatenateAndSort(this.store.select('ioHistory'));
        var historyAll = this.helperService.concatenateAndSort(localHistory);
        this.domOpsService.loadConversations(historyAll);
    };
    CardService.prototype.getCommandCard = function (cardTitle, cardContent, data, type) {
        return new Card(cardTitle, cardContent, data, type, Date.now() / 1000, 'command-card');
    };
    CardService.prototype.getResponseCard = function (cardTitle, cardContent, data, type) {
        return new Card(cardTitle, cardContent, data, type, Date.now() / 1000, 'response-card');
    };
    CardService.prototype.getDisplayTime = function (timestamp) {
        var start = timestamp;
        var current = Date.now() / 1000;
        var difference = current - start;
        var days = Math.floor(difference / 86400);
        var hours = Math.floor((difference - (days * 86400)) / 3600);
        var minutes = Math.floor((difference - (days * 86400) - (hours * 3600)) / 60);
        var secs = Math.floor((difference - (days * 86400) - (hours * 3600) - (minutes * 60)));
        var displayTime = "";
        if (days != 0) {
            displayTime = displayTime + days + " days ago";
            if (days == 1) {
                return 'Yesterday';
            }
            else {
                return displayTime;
            }
        }
        if (hours != 0) {
            displayTime = displayTime + hours + " hours ago";
            if (hours == 1) {
                return 'an hour ago';
            }
            else {
                return displayTime;
            }
        }
        if (minutes != 0) {
            displayTime = displayTime + minutes + " minutes ago";
            if (minutes == 1) {
                return 'a minute ago';
            }
            else {
                return displayTime;
            }
        }
        displayTime = displayTime + secs + " seconds ago";
        return displayTime;
    };
    CardService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [DomOpsService, HelperServiceService])
    ], CardService);
    return CardService;
}());
export { CardService };
//# sourceMappingURL=card.service.js.map